import React from 'react';
import PropTypes from 'prop-types';
import {Tooltip} from 'antd';
import IconWrapper from '../IconWrapper';
import {WarningIcon} from '../../icons';
import {colorsStyles} from '../../utils/styles';

const WarningTooltipIcon = ({title, size = 16}) => (
  <Tooltip title={title}>
    <IconWrapper color={colorsStyles.functional_warning} size={size} className='d-flex'>
      <WarningIcon />
    </IconWrapper>
  </Tooltip>
);

WarningTooltipIcon.propTypes = {
  title: PropTypes.node.isRequired,
  size: PropTypes.number,
};

export default WarningTooltipIcon;
